export default __webpack_public_path__ + "static/media/experian.46423547.png";